<!--
LISTAGEM SIMPLES DE CLIENTES
-->


<template>
  <div class="default-container p-3">
    <filtro
        :showfiltro="showfiltro"
        :params="paramsFiltro" 
        @change="filtroChange"
        @cancel="handleCloseFiltro"
    />
    <div class="row">
      <div class="col-12 mb-2">
          <span class="lbl-deal-title mb-2 w-100">LISTAGEM DE CLIENTES</span>
          <v-button label="Retornar para visões" icon="fa-bar-chart" class="float-right" @click="clickRetornar"></v-button>
      </div>
    </div>
    <hr />
    <div class="row mb-3 align-items-center">
      <div class="col-md-12 col-12 mb-3">
        <v-button label="Filtro" :success="true" @click="handleShowFiltro"></v-button>
      </div>
      <div class="col-12 p-3">
        <div class="border p-3" style="background: #f1f1f1">
          <div class="w-100 mb-2"><span>Selecione as colunas visíveis</span></div>
          <div class="form-check form-check-inline" style="min-width: 15%" v-for="(col, idx) in colunas" :key="idx">
              <input v-model="col.visible" class="form-check-input" type="checkbox" id="idx" value="option1">
              <label class="form-check-label" for="inlineCheckbox1">{{ col.label }}</label>
          </div>                                                   
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 lbl-title mb-2">
        CLIENTES
        <v-button label="Excel" class="float-right" @click="loadData(true)"></v-button>
        <!-- <v-button label="Imprimr" class="float-right"></v-button> -->
      </div>
    </div>

    <div class="row mb-5">
      <div class="col-12">
        <div style="width: 100%; max-height: 100%; overflow: hidden; font-size: 12px">
          <div style="overflow: auto">
              <table class="table table-striped table-hover responsive tablesorter w-100">
                  <thead>
                      <tr>
                        <template v-for="col in colunas">
                          <th v-if="col.visible" :class="col.class" :style="col.style">{{ col.label }}</th>
                        </template>
                      </tr>
                  </thead>
                  <tbody>
                      <tr v-for="(row, index) in dados.items" :key="index">
                          <td v-if="colunas[0].visible" :style="colunas[0].style" :class="colunas[0].class">{{ row.razao }}</td>
                          <td v-if="colunas[1].visible" :style="colunas[1].style" :class="colunas[1].class">{{ row.fantasia }}</td>
                          <td v-if="colunas[2].visible" :style="colunas[2].style" :class="colunas[2].class">{{ row.cnpjcpf | formatCNPJCPF }}</td>
                          <td v-if="colunas[3].visible" :style="colunas[3].style" :class="colunas[3].class">{{ row.iest }}</td>
                          <td v-if="colunas[4].visible" :style="colunas[4].style" :class="colunas[4].class">{{ row.endereco }}</td>
                          <td v-if="colunas[5].visible" :style="colunas[5].style" :class="colunas[5].class">{{ row.bairro }}</td>
                          <td v-if="colunas[6].visible" :style="colunas[6].style" :class="colunas[6].class">{{ row.cidade }}</td>
                          <td v-if="colunas[7].visible" :style="colunas[7].style" :class="colunas[7].class">{{ row.uf }}</td>
                          <td v-if="colunas[8].visible" :style="colunas[8].style" :class="colunas[8].class">{{ row.cep }}</td>
                          <td v-if="colunas[9].visible" :style="colunas[9].style" :class="colunas[9].class">{{ row.nome_usuario }}</td>
                          <td v-if="colunas[10].visible" :style="colunas[10].style" :class="colunas[10].class">{{ row.nome_segmento }}</td>
                          <td v-if="colunas[11].visible" :style="colunas[11].style" :class="colunas[11].class">{{ row.nome_grupo }}</td>
                          <td v-if="colunas[12].visible" :style="colunas[12].style" :class="colunas[12].class"><span v-for="(fone, index) in row.telefones" :key="index">{{ fone |formatFone }}<br></span></td>
                          <td v-if="colunas[13].visible" :style="colunas[13].style" :class="colunas[13].class"><span v-for="(email, index) in row.emails" :key="index">{{ email |formatFone }}<br></span></td>
                      </tr>
                  </tbody>
                  <tfoot>
                      <tr>
                          <th class="text-right total">Total</th>
                          <th class="numerico total">{{ dados.length }}</th>
                          <th class="total"></th>
                          <th class="total"></th>
                          <th class="total"></th>
                          <th class="total"></th>
                          <th class="total"></th>
                          <th class="total"></th>
                          <th class="total"></th>
                          <th class="total"></th>
                          <th class="total"></th>
                          <th class="total"></th>
                          <th class="total"></th>
                          <th class="total"></th>
                      </tr>
                  </tfoot>
              </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DashCard from "../dashboards/dash-card";
import Chart from "./chart";
import Filtro from "./filtro";
import { apiORDSpost, apiORDS } from "../shared/api-functions";
import { apiDownload2 } from "../shared/api-functions";

export default {
  components: {
    DashCard,
    Filtro,
    Chart,
  },

  data() {
    return {
      showfiltro: false,

      dados: {},
      dadosGrafico: null,

      //OBJETO PARA MONTAGEM DO FILTRO DA CONSULTA
      paramsFiltro: {

        filtros: [
          {
            nome: "usuario",
            label: null,
            url: null,
            varios: true,
            values: [],
          },
          {
            nome: "segmento",
            label: null,
            url: null,
            varios: true,
            values: [],
          },
          {
            nome: "grupocliente",
            label: null,
            url: null,
            varios: true,
            values: [],
          },
          {
            nome: "estado",
            label: null,
            url: null,
            varios: true,
            values: [],
          },
        ],
        
      },

      filtro: {
      },

      colunas: [
      ],

      nextPage: false,

    };
  },

  computed: {
    // paramsChart: function () {
    //   return { chart: { type: "ColumnChart" }, values: this.chartValues, colors: this.colors }
    // },

    // chartValues: function () {
    //   if (!this.dadosGrafico || this.dadosGrafico.grafico.length == 0)
    //     return []
    //   else
    //     return this.dadosGrafico.grafico
    // },
  },

  watch: {
  },

  methods: {
    handleCloseFiltro(){
            this.showfiltro = false
        },
    clickRetornar () {
      this.$router.push('/')
    },

    montaColunas () {
        this.colunas = [
            { nome: 'razao', visible: true, label: 'Nome/Razão', sortable: true, orderby: null, class: '', style: 'width: 280px;' },
            { nome: 'fantasia', visible: true, label: 'Nome Fantasia', sortable: true, orderby: null, class: '', style: 'width: 280px;' },
            { nome: 'cnpjcpf', visible: true, label: 'CNPJ/CPF', sortable: false, orderby: null, class: 'size130', style: '' },
            { nome: 'iest', visible: true, label: 'Inscrição Est', sortable: false, orderby: null, class: 'size130', style: '' },
            { nome: 'endereco', visible: true, label: 'Endereço', sortable: false, orderby: null, class: '', style: 'width: 280px;' },
            { nome: 'bairro', visible: true, label: 'Bairro', sortable: false, orderby: null, class: '', style: 'width: 280px;' },
            { nome: 'cidade', visible: true, label: 'Cidade', sortable: false, orderby: null, class: '', style: 'width: 280px;' },
            { nome: 'uf', visible: true, label: 'Estado', sortable: false, orderby: null, class: '', style: '' },
            { nome: 'cep', visible: true, label: 'Cep', sortable: false, orderby: null, class: '', style: '' },
            { nome: 'nome_usuario', visible: true, label: 'Usuario', sortable: true, orderby: null, class: 'size130', style: '' },
            { nome: 'nome_segmento', visible: true, label: 'Segmento', sortable: true, orderby: null, class: 'size130', style: '' },
            { nome: 'nome_grupo', visible: true, label: 'Grupo de cliente', sortable: true, orderby: null, class: 'size130', style: '' },
            { nome: 'telefone', visible: true, label: 'Telefones', sortable: true, orderby: null, class: 'size130', style: 'min-width: 180px;' },
            { nome: 'email', visible: true, label: 'Emails', sortable: true, orderby: null, class: 'size130', style: 'min-width: 120px;' },
        ]
    },

    handleShowFiltro() {
     
      this.showfiltro = true

    },

    filtroChange(filtro) {
      this.showfiltro = false;

      this.filtro = filtro;

      this.paramsFiltro.filtros[0].values = this.filtro.usuario
      this.paramsFiltro.filtros[1].values = this.filtro.segmento
      this.paramsFiltro.filtros[2].values = this.filtro.grupocliente
      this.paramsFiltro.filtros[3].values = this.filtro.estado

      this.loadData();
    },

    scroll () {
      window.onscroll = () => {
        if (this.nextPage)
          return        
        let bottomOfWindow = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight === document.documentElement.offsetHeight
        if (bottomOfWindow) {
          this.loadData(false, true)
        }
        // SysVars.scrollPosition = document.documentElement.scrollTop
      }
    },

    async loadData(excel, loadMore) {
      
      let url = "consulta/vendas/listagemclientes";
      // let url = "consulta/teste";

      if (loadMore)
        if (this.dados.has_more) {
          this.filtro.page = this.dados.next_page
          this.nextPage = true
        }
        else
          return

      this.filtro.excel = excel

      if (excel) { 
        this.filtro.page = null
        apiDownload2(this, url, this.filtro, "post")
      }
      else {
        const data = await apiORDSpost(this.$store, url, this.filtro, "post")
        if (data) {
          if (loadMore) {
            this.dados.items.push(...data.items)
            this.dados.has_more = data.has_more
            this.dados.next_page = data.next_page
          }
          else
            this.dados = data
        } else {
          this.dados = [];
        }
        this.montaColunas()
      }

      let self = this
      this.$nextTick(function () {
        self.nextPage = false
      })

    },
  },

  mounted() {
    this.scroll()
  },

  destroyed () {
    window.onscroll = null
  },

  created() {
    this.loadData()
  },
}


</script>

<style>

table .numerico {
  min-width: 65px;
  text-align: right;
}

table .size130 {
  min-width: 130px;
}

table .total {
    background: #c1c4c7;
    border: none;
}

table .var {
    min-width: 85px;
    text-align: center;
    background: #c1c4c7;
    display: inline-block;
}

table .var-negative {
    color: white;
    background: indianred;
}

table .var-positive {
    color: white;
    background: green;
}

table .border-left {
  border-left: 1px solid #dee2e6;
}

.resumo__performance {
  display: flex;
  align-items: center;
  justify-content: space-between;  
}

.resumo__performance__value {
    padding: 5px 15px;
    font-size: 18px;
    font-weight: 600;
    text-align: left;
    border-radius: 10%;
}

</style>



// WEBPACK FOOTER //
// src/consultas/listagem-clientes.vue